<template>
  <div v-show="isReady">

    <!-- <v-app v-if="!logged">
      <v-snackbar
        v-model="generalApp.snackbarShow"
        :color="generalApp.snackbarColor"
        :multi-line=true
        :timeout=8000
        top
        right
      >
        {{ generalApp.snackbarMessage }}
        <v-btn
          dark
          text
          @click="closeSnack()"
        >
          {{$t('buttons.close')}}
        </v-btn>
      </v-snackbar>
      <Login />
    </v-app> -->

    <v-app
      id="app"
    >
      <v-snackbar
        v-model="generalApp.snackbarShow"
        :color="generalApp.snackbarColor"
        :multi-line=true
        :timeout=8000
        top
        right
      >
        {{ generalApp.snackbarMessage }}
        <v-btn
          dark
          text
          @click="closeSnack()"
        >
          {{$t('buttons.close')}}
        </v-btn>
      </v-snackbar>
      <v-navigation-drawer
        v-if="isLoggedIn"
        v-model="drawer"
        fixed
        clipped
        app
        temporary
        width="154"
        v-show="showApp"
      >
        <v-list dense>
          <template v-for="(item, i) in items">
            <v-list-group
              v-if="item.children"
              v-model="item.model"
              :key="item.text"
              :append-icon="item.model ? item.icon : item['icon-alt']"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(child, k) in item.children"
                :key="k"
                @click="changeRoute(child.href)"
              >
                <v-list-item-content class="pl-3">
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="i"
              @click="changeRoute(item.href)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar
        dark
        flat
        fixed
        clipped-left
        v-show="showApp"
        app
        color="primary"
        class="primary_text--text app-main-toolbar"
      >
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          @mouseover="drawer = true"
          class="primary_text--text"
        ></v-app-bar-nav-icon>
        <v-toolbar-title class="pr-3">
          <span class="title">
            {{$t('app_title')}}
          </span>
        </v-toolbar-title>
        <!-- <v-text-field
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          :label="$t('search')"
          class="hidden-sm-and-down"
        ></v-text-field> -->
        <v-spacer />
        <div class="locale-changer">
            <v-menu
              offset-y
            >
            <template v-slot:activator="{ on }">
              <v-btn
                dark
                v-on="on"
                class="mr-1"
              >
                <country-flag :country='buttonFlagIcon' size='normal'/>
              </v-btn>
            </template>
            <v-list
            dense
            >
              <v-list-item-group>
                <v-list-item
                  v-for="(lang, i) in langs"
                  :key="`Lang${i}`"
                  :value="lang.code"
                  @click="handleSelectLang(lang.code)"
                >
                  <v-list-item-icon>
                    <country-flag class="flag-icon" :country='lang.imgFlag' size='normal'/>
                  </v-list-item-icon>
                  <v-list-item-content
                  >
                    <v-list-item-title class="mt-3 ml-0">
                      {{ lang.langName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            </v-menu>
          </div>
          <!-- <v-btn
            icon
            dark
          >
            <v-icon>message</v-icon>
          </v-btn>
          <v-btn
            v-if="!notifications_components_enable"
            icon
            dark
          >
            <v-icon>notifications</v-icon>
          </v-btn>
          <Notifications v-else/> -->
        <template v-if="isLoggedIn">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                dark
                v-on="on"
                class="mr-5"
                width="90"
              >
                <v-icon>person</v-icon> {{ cognito.user.name }}
              </v-btn>
            </template>
            <v-list class="user-menu">
              <!-- TODO: change to logged user profile -->
              <!-- <v-list-item @click="changeRoute({name: 'UserProfile', params: { userID: cognito.user.username }})">
                <v-list-item-title>
                  {{$t('general.my_profile')}}
                </v-list-item-title>
              </v-list-item> -->
              <!-- <v-list-item @click="changeRoute({name: 'CompanyDetail', params: { companyID: signedInCompany.id }})">
                <v-list-item-title>
                  {{$t('general.my_company')}}
                </v-list-item-title>
              </v-list-item> -->
              <v-list-item @click="changeRoute('Upload')">
                <v-list-item-title>
                  {{$t('general.upload')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="showIntercome()">
                <v-list-item-title>
                  {{$t('general.support')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="handleLogOut">
                <v-list-item-title>
                  {{$t('logout')}}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-app-bar>
      <v-main>
        <router-view></router-view>
        <wrld-overlay-loader />
      </v-main>
      <div v-if="intercomIsOpen" id="intercom-close-btn" @click="closeIntercom()">
        <v-icon size="30" color="white">close</v-icon>
      </div>
    </v-app>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { Auth } from '@/_services/amplify.service.js'
import router from './router'
import moment from 'moment-timezone'
import CountryFlag from 'vue-country-flag'
// import Notifications from './views/notifications/NotificationsIcon.vue'
import { getLoggedUser } from '@/_services/amplify.service'

export default {
  name: 'App',
  data () {
    return {
      // langs: ['en', 'cs'],
      langs: [
        {
          code: 'en',
          imgFlag: 'gb',
          langName: 'English'
        },
        {
          code: 'cs',
          imgFlag: 'cz',
          langName: 'Czech'
        }
      ],
      flag: '',
      nav: 0,
      showApp: true,
      drawer: null,
      intercomIsOpen: false,
      intercomBooted: false,
      notifications_components_enable: process.env.VUE_APP_NOTIFICATIONS_ENABLE !== undefined, // TODO enable/disable notifications component
      amplifySession: null
    }
  },
  components: {
    // Notifications
    CountryFlag
  },
  computed: {
    ...mapGetters({
      // session: 'cognito/session',
      getWrldUserLang: 'wrldUser/getWrldUserLang'
  }),
    ...mapState(['isReady', 'cognito', 'generalApp', 'signedInCompany']),
    isLoggedIn () {
      const session = this.cognito.session
      this.amplifySession = session
      if (!session) return (false)
      const accessToken = session.accessToken
      if (!accessToken) return (false)
      const hasToken = accessToken.jwtToken
      const isActive = new Date(accessToken.payload.exp * 1000) > new Date()
      return (hasToken && isActive)
      // return true // TODO removed when algolia logged in user
    },
    items () {
      let menuItems = [
        { text: this.$i18n.t('menu.organizations'), href: 'OrganizationsOverview' },
        { text: this.$i18n.t('menu.orders'), href: 'OrdersOverview' },
        { text: this.$i18n.tc('transport_request.transport_request', 2), href: 'TransportRequest' },
        { text: this.$i18n.t('menu.shipments'), href: 'Shipments' },
        // { text: this.$i18n.t('menu.shipments'), href: 'ShipmentsOverview' },
        // { text: this.$i18n.t('menu.shipments_group_by_day'), href: 'ShipmentsGroupByDay' },
        { text: this.$i18n.t('drops.drops'), href: 'DropOverview' }, // TODO locale
        { text: this.$i18n.t('planner.planner'), href: { path: `planner?day=${moment().unix()}` } },
        {
          text: this.$i18n.tc('menu.reports', 2),
          model: false,
          children: [
            // { text: this.$i18n.t('menu.orders'), href: 'OrdersReport' },
            { text: this.$i18n.t('menu.shipments'), href: 'ShipmentsReport' }
          ]
        }

      ]
      if (this.amplifySession != null) {
        if(this.amplifySession.getIdToken().payload.org === 'ea22334c-25eb-4eb7-bc70-1f30a04d7544') {
          return menuItems
        }
      }
      return menuItems.filter(({ href }) => {
        return href != 'TransportRequest'
      })
    },
    buttonFlagIcon () {
      switch (this.$i18n.locale) {
        case 'en':
          return 'gb'
        case 'cs':
          return 'cz'
      }
    }
  },
  methods: {
    ...mapActions({
      signOut: 'cognito/signOut',
      logOutUser: 'logOutUser',
      closeSnackbar: 'closeSnackbar',
      setDrawerMenu: 'setDrawerMenu',
      showSnackbar: 'showSnackbar',
      setWrldUserLang: 'wrldUser/setWrldUserLang'
    }),
    closeSnack () {
      this.closeSnackbar()
    },
    changeRoute (href) {
      if (href.params != null) {
        router.push({ name: href.name, params: href.params })
      } else if (href.path !== undefined) {
        router.push({ path: href.path })
      } else {
        router.push({ name: href })
      }
    },
    getLinkPath (href) {
      let route = null
      if (href.params != null) {
        route = { name: href.name, params: href.params }
      } else {
        route = { name: href }
      }
      const path = router.resolve(route)
      return path
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    handleLogOut () {
      Auth.signOut().then(() => {
        this.signOut()
        this.$store.dispatch('setLogOutUser')
        this.$store.dispatch('resetState')
        this.$nextTick(() => {
          this.$router.push({ path: '/login' })
        })
      })
    },
    showIntercome () {
        getLoggedUser().then(({ user }) => {
          window.Intercom('boot', {
            app_id: 'fx5x0kcb',
            email: user.email,
            // name: this.name,
            user_id: user['cognito:username']
          })
        })
      this.intercomIsOpen = true
      window.Intercom('show')
    },
    closeIntercom () {
      this.intercomIsOpen = false
      window.Intercom('hide')
    },
    handleSelectLang (lang) {
      this.setWrldUserLang({ lang })
    }
  },
  watch: {
    drawer (newVal, oldVal) { // TODO: Probably just temporal thing
      if (newVal !== oldVal) {
        this.setDrawerMenu(newVal)
      }
    },
    getWrldUserLang: {
      immediate: true,
      deep: true,
      handler (val, oldVal) {
        this.$i18n.locale = val
      }
    }
  },
  created () {
    this.drawer = false
    // if (navigator.language === 'cs' || navigator.language === 'cs-CZ' ||
    //     navigator.language === 'sk' || navigator.language === 'sk-SK'
    // ) {
    //   this.$root.$i18n.locale = 'cs'
    // }
  }
}
</script>

<style lang="scss">
#app {
  background-color: #FAFAFA;
  position: relative;
}
.clickableTableRow {
  cursor: pointer;
}
.locale-changer select {
  padding: 5px;
  cursor: pointer;
}
.locale-changer option {
  color: black;
}
.user-menu .v-list__tile__title {
  text-align: right;
}
span.filter-chip {
    background-color: #e0e0e0;
    padding: 5px;
    margin: 3px;
    border-radius: 7px;
    font-size: 13px;
    line-height: 30px;
}
.v-card.rounded-card {
  border-radius: 5px;
}
#intercom-close-btn {
  cursor: pointer;
  z-index: 999999;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  padding: 15px;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 32px 0px;
  border-radius: 50%;
  background: rgb(255, 74, 87);
  // transition: opacity 0.3s ease 0s;
}
.flag-icon {
  margin-right: -30px;
  margin-left: -10px;
  border: 1px solid #D3D3D3;
}
</style>
